<template>
  <section class="fixed inset-0 flex items-center justify-center z-[31] bg-black bg-opacity-30 backdrop-blur-sm mt-[70px]">
    <div id="modal-export-report" 
      class="modal relative block bg-white dark:bg-dark-800 w-5/6 max-w-3xl shadow-md rounded-lg dark:shadow-dark-600 transform transition-all duration-300 ease-in-out">
      <div id="modal-header" class="w-full bg-primary dark:bg-dark-600 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">Export Laporan Penjualan</h5>
      </div>
      <div id="modal-body" class="p-5 space-y-4">
        <!-- Date Range Selection -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Pilih Periode</label>
          <div class="flex flex-col space-y-4">
            <!-- Date Range Option -->
            <div class="flex items-center">
              <input type="radio" id="dateRange" value="range" v-model="exportType" class="h-4 w-4 text-primary">
              <label for="dateRange" class="ml-2 text-sm text-gray-700 dark:text-gray-300">Rentang Tanggal</label>
            </div>
            
            <div v-if="exportType === 'range'" class="ml-6 space-y-4">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Dari Tanggal</label>
                  <input type="date" v-model="dateRange.start" 
                    class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary dark:bg-dark-700 dark:text-white">
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Sampai Tanggal</label>
                  <input type="date" v-model="dateRange.end" 
                    class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary dark:bg-dark-700 dark:text-white">
                </div>
              </div>
            </div>

            <!-- Monthly Option -->
            <div class="flex items-center">
              <input type="radio" id="monthly" value="monthly" v-model="exportType" class="h-4 w-4 text-primary">
              <label for="monthly" class="ml-2 text-sm text-gray-700 dark:text-gray-300">Bulanan</label>
            </div>

            <div v-if="exportType === 'monthly'" class="ml-6 space-y-4">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Bulan</label>
                  <select v-model="selectedMonth" 
                    class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary dark:bg-dark-700 dark:text-white">
                    <option v-for="(month, index) in months" :key="index" :value="index + 1">
                      {{ month }}
                    </option>
                  </select>
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Tahun</label>
                  <select v-model="selectedYear" 
                    class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary dark:bg-dark-700 dark:text-white">
                    <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Export Options -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Format Ekspor</label>
          <div class="flex space-x-4">
            <label class="inline-flex items-center">
              <input type="radio" v-model="exportFormat" value="excel" class="h-4 w-4 text-primary">
              <span class="ml-2 text-gray-700 dark:text-gray-300">Excel (.xlsx)</span>
            </label>
          </div>
        </div>

        <!-- Loading State -->
        <div v-if="isLoading" class="text-center py-4">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
          <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">Menyiapkan laporan...</p>
        </div>

        <!-- Error Message -->
        <div v-if="errorMessage" class="p-3 bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300 rounded-md text-sm">
          {{ errorMessage }}
        </div>
      </div>
      <div class="modal-footer p-5 border-t border-gray-200 dark:border-gray-700">
        <div class="flex justify-between">
          <button @click="closeModal" 
            class="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-dark-700 hover:bg-gray-50 dark:hover:bg-dark-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary">
            Batal
          </button>
          <button @click="handleExport" 
            :disabled="isLoading"
            class="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50">
            <span v-if="!isLoading">Ekspor Laporan</span>
            <span v-else>Mengekspor...</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ModalExportReportDaily",
  data() {
    return {
      exportType: 'range', // 'range' or 'monthly'
      dateRange: {
        start: new Date().toISOString().split('T')[0],
        end: new Date().toISOString().split('T')[0]
      },
      selectedMonth: new Date().getMonth() + 1,
      selectedYear: new Date().getFullYear(),
      exportFormat: 'excel',
      includeDetails: true,
      includeSummary: true,
      isLoading: false,
      errorMessage: '',
      months: [
        'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
        'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
      ],
      years: Array.from({length: 10}, (_, i) => new Date().getFullYear() - i)
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    validateForm() {
      if (this.exportType === 'range') {
        if (!this.dateRange.start || !this.dateRange.end) {
          this.errorMessage = 'Harap pilih rentang tanggal yang valid';
          return false;
        }
        if (new Date(this.dateRange.start) > new Date(this.dateRange.end)) {
          this.errorMessage = 'Tanggal mulai tidak boleh lebih besar dari tanggal akhir';
          return false;
        }
      }
      return true;
    },
    async handleExport() {
      if (!this.validateForm()) return;

      this.isLoading = true;
      this.errorMessage = '';

      try {
        let startDate, endDate;
        
        if (this.exportType === 'monthly') {
          // Set to first day of month at 00:00:00 in local time
          startDate = new Date(Date.UTC(this.selectedYear, this.selectedMonth - 1, 1, 0, 0, 0));

          // Set to last day of month at 23:59:59.999 in local time
          endDate = new Date(Date.UTC(this.selectedYear, this.selectedMonth, 0, 23, 59, 59, 999));
        } else {
          startDate = new Date(this.dateRange.start);
          endDate = new Date(this.dateRange.end);
        }

        // Format dates for the export
        const formatDate = (date) => {
          return date.toISOString().split('T')[0];
        };

        // Emit event with export parameters
        this.$emit('submit', {
          startDate: formatDate(startDate),
          endDate: formatDate(endDate),
          includeDetails: this.includeDetails,
          includeSummary: this.includeSummary,
          format: this.exportFormat
        });

        // Close modal after a short delay to show success state
        setTimeout(() => {
          this.isLoading = false;
          this.closeModal();
        }, 500);

      } catch (error) {
        console.error('Export error:', error);
        this.errorMessage = 'Terjadi kesalahan saat memproses ekspor. Silakan coba lagi.';
        this.isLoading = false;
      }
    }
  },
  mounted() {
    // Set default end of month for monthly selection
    const today = new Date();
    this.selectedMonth = today.getMonth() + 1;
    this.selectedYear = today.getFullYear();
  }
}
</script>

<style scoped>
/* Add any custom styles here */
</style>